import { useEffect } from 'react';

/**
 * Reports "is this form submittable" out of Formik's render prop.
 *
 * FormBase takes `isSubmitDisabled` as a plain prop, so the page cannot read
 * Formik state when it renders. This lifts it back out, letting the Save button
 * stay locked until there is a valid change to save.
 */
const FormValidityWatcher = ({ canSave, onChange }) => {
    useEffect(() => {
        onChange(canSave);
    }, [canSave, onChange]);

    return null;
};

export default FormValidityWatcher;
